import type { ReactNode } from 'react'

/** 화면 제목/설명/우측 액션 — 화면마다 헤더 마크업을 복제하지 않기 위한 공통 조각. */
export function PageHeader({
  title,
  description,
  action,
}: {
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
}) {
  return (
    <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="space-y-1">
        <h2 className="text-lg font-semibold text-ink-700">{title}</h2>
        {description ? <p className="text-sm text-slateish-600">{description}</p> : null}
      </div>
      {action}
    </div>
  )
}
